import {SupportMailSection} from "../../../../../components/channels/telegram/FAQSection";
import {getMailBody, getMailSubject} from "../helpers/mail";

export const creator_DUMMY = {
  removeSupportChatButton: true,
  hideMemberCount: true,
  hideUserReviews: true,
  settings: {
    checkout: {
      enable_new_checkout: true,
    }
  },
  theme: {
    is_telegram_white_theme: true,
    is_whatsapp_white_theme: true,
  },
  fb_pixel: {
    // Note: This is just for testing, it will cause double events on our fb pixel of staging environment
    FB_PIXEL_IDS: [process.env.NEXT_PUBLIC_FB_PIXEL_ID]
  },
  custom_button_label: {
    recurring: 'View plans',
  },
  faqs: [
    {
      q: 'Have any query related to channel? Mail to us here',
      a: ({userData, pageUrl}) => {
        const mailId = 'examtakhindi@gmail.com';
        const mailSubject = getMailSubject(userData);
        const mailBody = getMailBody('examtaksupport', userData, pageUrl);

        return (
          <SupportMailSection
            description=""
            mailId={mailId}
            mailSubject={mailSubject}
            mailBody={mailBody}
          />
        );
      }
    },
    {
      q: 'Link for our free telegram community',
      a: () => (
        <p>
          Join us here: {" "}
          <a className="underline" href="https://t.me/examtaksupport" target="_blank">
            examtaksupport
          </a>
        </p>
      )
    }
  ]
};